import { render, staticRenderFns } from "./CorporateSalaryPackage.vue?vue&type=template&id=d58aafe2&scoped=true&"
import script from "./CorporateSalaryPackage.vue?vue&type=script&lang=js&"
export * from "./CorporateSalaryPackage.vue?vue&type=script&lang=js&"
import style0 from "./CorporateSalaryPackage.vue?vue&type=style&index=0&id=d58aafe2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58aafe2",
  null
  
)

export default component.exports